import React, { useMemo, Suspense } from "react";
import { ReactTyped } from "react-typed";
import { motion } from "framer-motion";

// 🧠 Lazy-load Robot to speed up first paint
// const Robot = React.lazy(() => import("./robot"));

function Hero() {
  // Pre-generate particle data ONCE
  const particles = useMemo(() => {
    return Array.from({ length: 20 }).map(() => ({
      size: Math.random() * 5 + 2,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      duration: Math.random() * 5 + 3,
      delay: Math.random() * 3,
    }));
  }, []);

  return (
    <section
      id="home"
      className="relative pt-24 text-gray-900 overflow-hidden bg-gradient-to-r from-[#0A2A43] via-[#1E90FF] to-[#87CEEB]"
      style={{ willChange: "transform, opacity", transform: "translateZ(0)" }}
    >
      {/* Subtle circuit texture */}
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage:
            "url('https://www.transparenttextures.com/patterns/circuits.png')",
          backgroundSize: "cover",
        }}
      />

      {/* Rotating Tech Wheel */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="absolute w-[160%] h-[160%] rounded-full bg-[radial-gradient(circle,rgba(30,144,255,0.15)_0%,transparent_70%)] blur-3xl" />

        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 400 400"
          className="w-[120%] h-[120%] text-blue-300 drop-shadow-[0_0_20px_rgba(0,170,255,0.3)]"
          animate={{ rotate: 360 }}
          transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
        >
          <circle cx="200" cy="200" r="170" stroke="#1E90FF" strokeWidth="1" fill="none" />
          <circle cx="200" cy="200" r="140" stroke="#00BFFF" strokeWidth="0.7" opacity="0.7" fill="none" />
          <circle cx="200" cy="200" r="100" stroke="#66CCFF" strokeWidth="0.5" opacity="0.4" fill="none" />
        </motion.svg>

        <motion.div
          className="absolute w-[90%] h-[90%] rounded-full border border-cyan-300/30 blur-[1.5px]"
          animate={{ scale: [1, 1.06, 1], opacity: [0.4, 0.8, 0.4] }}
          transition={{ duration: 3.5, repeat: Infinity }}
        />
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {particles.map((p, i) => (
          <motion.div
            key={i}
            className="absolute bg-blue-400/40 rounded-full blur-md"
            style={{
              width: p.size,
              height: p.size,
              top: p.top,
              left: p.left,
            }}
            animate={{ y: [0, -20, 0], opacity: [0.2, 0.8, 0.2] }}
            transition={{
              duration: p.duration,
              repeat: Infinity,
              delay: p.delay,
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-28 flex flex-col md:flex-row items-center gap-12">
        {/* Left Side */}
        <motion.div
          initial={{ x: -60, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="flex-1"
        >
          <h1 className="text-3xl md:text-5xl font-extrabold text-blue-50 mb-6">
            SPK MAK <span className="text-blue-200">TECHNOLOGIES</span>
          </h1>

          <h2 className="text-xl md:text-2xl font-semibold text-blue-100">
            We specialize in{" "}
            <span className="text-blue-50 font-bold">
              <ReactTyped
                strings={[
                  "ODM Solutions",
                  "Robotics",
                  "Embedded Systems",
                  "IOT Devices",
                  "AI ML Solutions",
                  "CAD Designing",
                ]}
                typeSpeed={60}
                backSpeed={40}
                loop
              />
            </span>
          </h2>

          <p className="mt-6 text-blue-50/90 max-w-xl">
            SPK-MAK Technologies Pvt. Ltd. is a forward-thinking tech company offering
            end-to-end electronic product engineering and ODM solutions.
          </p>

          {/* ONLY Contact Us remains */}
          <div className="mt-8">
            <a
              href="#contact"
              className="border border-blue-400 text-blue-50 px-6 py-3 rounded-lg"
            >
              Contact Us
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
